"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachLine2 = function SvgBeachLine2(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.099 3.099c1.275-1.275 3.826-1.275 8.926-1.275 5.101 0 7.652 0 8.927 1.275 1.275 1.275 1.275 3.826 1.275 8.926 0 10.202 0 10.202-10.202 10.202-5.1 0-7.65 0-8.926-1.275-1.275-1.275-1.275-3.826-1.275-8.927 0-5.1 0-7.65 1.275-8.926Zm4.41 10.319h2.672v.848H6.096v-.856l2.095-1.729c.343-.282.58-.533.709-.75a1.36 1.36 0 0 0 .197-.718c0-.278-.09-.497-.263-.661-.168-.169-.396-.253-.684-.253-.314 0-.57.093-.765.278-.19.184-.309.443-.352.774H5.98c.05-.593.266-1.06.646-1.402.385-.342.895-.514 1.524-.514.404 0 .757.074 1.06.22.31.147.548.354.72.62.174.26.26.56.26.898 0 .277-.043.527-.132.75a2.127 2.127 0 0 1-.43.677 8.345 8.345 0 0 1-.857.792L7.51 13.418Zm5.797-1.974H10.94v.897h2.366v-.897Zm3.404 2.821h1.036v-4.151h-1.941c-.555 0-.986.125-1.29.375-.303.245-.456.598-.456 1.06 0 .32.079.59.237.808.157.213.384.364.678.457l-1.02 1.451h1.125l.931-1.33h.7v1.33Zm-.765-3.352h.766v1.256h-.766c-.56 0-.84-.196-.84-.62s.28-.636.84-.636Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBeachLine2);
var _default = exports["default"] = Memo;